import { FaListCheck, FaFileLines, FaTable, FaClock, FaComment, FaImage, FaCloud, FaFolderOpen, FaChartLine, FaPen, FaLink } from 'react-icons/fa6';
import TodoComponent from '../IdeaComponents/TodoComponent';
import NotepadComponent from '../IdeaComponents/NotepadComponent';
import TableComponent from '../IdeaComponents/TableComponent';
import CountdownComponent from '../IdeaComponents/CountdownComponent';
import ChatComponent from '../IdeaComponents/ChatComponent';
import GalleryComponent from '../IdeaComponents/GalleryComponent';
import MoodboardComponent from '../IdeaComponents/MoodboardComponent';
import FilestorageComponent from '../IdeaComponents/FilestorageComponent';
import FlowDiagramComponent from '../IdeaComponents/FlowDiagramComponent';
import WhiteboardComponent from '../IdeaComponents/WhiteboardComponent';
import LinkListComponent from '../IdeaComponents/LinkListComponent';

export const COMPONENT_TYPES = [
  {
    type: 'todo',
    name: 'To-Do List',
    description: 'Track tasks with a checklist',
    icon: <FaListCheck />,
    component: TodoComponent
  },
  {
    type: 'notepad',
    name: 'Notepad',
    description: 'Simple text editor for notes',
    icon: <FaFileLines />,
    component: NotepadComponent
  },
  {
    type: 'table',
    name: 'Table',
    description: 'Organize data in rows and columns',
    icon: <FaTable />,
    component: TableComponent
  },
  {
    type: 'countdown',
    name: 'Countdown',
    description: 'Visual timer with progress circle',
    icon: <FaClock />,
    component: CountdownComponent
  },
  {
    type: 'chat',
    name: 'AI Chat',
    description: 'Chat with DeepSeek AI assistant',
    icon: <FaComment />,
    component: ChatComponent
  },
    {
    type: 'gallery',
    name: 'Gallery',
    description: 'Grid-based image gallery',
    icon: <FaImage />,
    component: GalleryComponent,
    aiExcluded: true
  },
  {
    type: 'moodboard',
    name: 'Moodboard',
    description: 'Cloud layout for images and text',
    icon: <FaCloud />,
    component: MoodboardComponent,
    aiExcluded: true
  },
  {
    type: 'filestorage',
    name: 'File Storage',
    description: 'List-based file storage',
    icon: <FaFolderOpen />,
    component: FilestorageComponent,
    aiExcluded: true
  },
  {
    type: 'flowdiagram',
    name: 'Flow Diagram',
    description: 'Create flowcharts and process diagrams',
    icon: <FaChartLine />,
    component: FlowDiagramComponent
  },
  {
    type: 'whiteboard',
    name: 'Whiteboard',
    description: 'Drawing canvas for sketches and diagrams',
    icon: <FaPen />,
    component: WhiteboardComponent,
    aiExcluded: true
  },
  {
    type: 'linklist',
    name: 'Link List',
    description: 'Save and preview web links with metadata',
    icon: <FaLink />,
    component: LinkListComponent
  }
];

export const getComponentByType = (type) => {
  return COMPONENT_TYPES.find(comp => comp.type === type);
};